import { KeyboardEvent } from 'react';

const ALLOWED_KEYS = [
  8, // Backspace
  9, // Tab
  13, // Enter
  27, // Escape
  33, // Pgup
  34, // Pgdown
  35, // End
  36, // Home
  37, // ArrowLeft
  38, // ArrowUp
  39, // ArrowRight
  40, // ArrowDown
  46, // Delete
];

export function isNumericKey(code: number) {
  return (code >= 48 && code <= 57) || (code >= 96 && code <= 105);
}

export function isDecimalKey(code: number) {
  return code === 110 || code === 190;
}

export function isMetaKeyAllowed(event: KeyboardEvent) {
  const key = event.keyCode;
  const allowed = ALLOWED_KEYS.includes(key);

  return event.altKey || event.ctrlKey || event.metaKey || allowed;
}

export function isInputTextSelected(value) {
  const selection = window.getSelection().toString() ?? null;
  return selection ? value.indexOf(selection) > -1 : false;
}

/**
 * Determine if the event is a valid numeric keyboard event.
 * We use this so we can prevent non-number characters in the input
 */
export function isValidNumericKeyboardEvent(
  event: React.KeyboardEvent,
  value?: string
) {
  const code = event.keyCode;

  if (event.key == null) return true;

  let allowed = false;

  if (code === undefined || isMetaKeyAllowed(event)) {
    allowed = true;
  } else if (isNumericKey(code) && !event.shiftKey) {
    allowed = true;
  } else if (isNumericKey(code) && isInputTextSelected(value)) {
    allowed = true;
  } else if (
    isDecimalKey(code) &&
    (!value.length || value.indexOf('.') === -1)
  ) {
    allowed = true;
  }

  return allowed;
}

export function getStepFactor(event: React.KeyboardEvent) {
  let ratio = 1;

  if (event.metaKey || event.ctrlKey) {
    ratio = 0.1;
  }

  if (event.shiftKey) {
    ratio = 10;
  }

  return ratio;
}
